import { AnyAction, Reducer } from 'redux';

export const STORE_USER_PROFILE = 'user/store-user-profile';
export const SELECT_USER_PROFILE = 'plan/select-user-profile';

export const STORE_USERNAME = 'user/store-username';
export const STORE_PASSWORD = 'user/store-password';

export interface UserDetail {
    s: string;
    ugroup: string;
    uroles: string;
    userName: string;
    userGroup: string;
    groupNo: string;
    email: string;
    nickName: string;
    userType: string;
    mobileNumber: string;
    allUserGroup: string;
    responsibilies: string;
    roleName: string;
    labCode: string;
    dmeRequired: string;
}

export interface UserState {
    userDetails: UserDetail;
    username?: string;
    password?: string;
}

const initialState: UserState = {
    userDetails: {
        s: '',
        ugroup: '',
        uroles: '',
        userName: '',
        userGroup: '',
        groupNo: '',
        email: '',
        nickName: '',
        userType: '',
        mobileNumber: '',
        allUserGroup: '',
        responsibilies: '',
        roleName: '',
        labCode: '',
        dmeRequired: ''
    }
};

const reducer: Reducer<UserState> = (state: UserState = initialState, action: AnyAction): UserState => {
    switch (action.type) {
        case STORE_USER_PROFILE:
            return {
                ...state,
                userDetails: action.userDetails,
            };
        case STORE_USERNAME:
            return {
                ...state,
                username: action.username
            };
        case STORE_PASSWORD:
            return {
                ...state,
                password: action.password
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/user.tsx